import company1 from './assets/company/01.png';
import company2 from './assets/company/02.png';
import company3 from './assets/company/03.png'
import company4 from './assets/company/04.png'
import company5 from './assets/company/05.png'
import company6 from './assets/company/06.png'
import company7 from './assets/company/07.png'
import company8 from './assets/company/08.png'
import company9 from './assets/company/09.png'
import company10 from './assets/company/10.png'
import company11 from './assets/company/11.png'
import company12 from './assets/company/12.png'
import company13 from './assets/company/13.png'
import company14 from './assets/company/14.png'
import company15 from './assets/company/15.png'
import company16 from './assets/company/16.png'
import company17 from './assets/company/17.png'
import company18 from './assets/company/18.png'
import company19 from './assets/company/19.png'
import company20 from './assets/company/20.png'
import company21 from './assets/company/21.png'

export var companyList = [
    company1, company2, company3, company4, company5, company6, company7,
    company8, company9, company10, company11, company12, company13, company14,
    company15, company16, company17, company18, company19, company20, company21,
]

import side1 from './assets/team/side1.png'
import side2 from './assets/team/side2.png'
import side3 from './assets/team/side3.png'
import side4 from './assets/team/side4.png'
import side5 from './assets/team/side5.png'
import side6 from './assets/team/side6.png'

export var sideList = [side1, side2, side3, side4, side5, side6, ]

// 产品页面图片
//  1.日常办公
import office1 from './assets/product/office/1.png'
import office2 from './assets/product/office/2.png'
import office3 from './assets/product/office/3.png'
import office4 from './assets/product/office/4.png'
//  2。团队协作
import team1 from './assets/product/team/1.png'
import team2 from './assets/product/team/2.png'
import team3 from './assets/product/team/3.png'
import team4 from './assets/product/team/4.png'
// 3.crm
import crm1 from './assets/product/crm/1.png'
import crm2 from './assets/product/crm/2.png'
import crm3 from './assets/product/crm/3.png'
import crm4 from './assets/product/crm/4.png'
import crm5 from './assets/product/crm/5.png'
// 4hrm 
import hrm1 from './assets/product/hrm/1.png'
import hrm2 from './assets/product/hrm/2.png'
import hrm3 from './assets/product/hrm/3.png'
// import hrm4 from './assets/product/hrm/4.png'
// import hrm5 from './assets/product/hrm/5.png'
import hrm6 from './assets/product/hrm/6.png'
// 5.admin 
import admin1 from './assets/product/admin/1.png'
import admin2 from './assets/product/admin/2.png'
import admin3 from './assets/product/admin/3.png'
import admin4 from './assets/product/admin/4.png'
import admin5 from './assets/product/admin/5.png'
import admin6 from './assets/product/admin/6.png'
import admin7 from './assets/product/admin/7.png'
// import admin8 from './assets/product/admin/8.png'
// 6企业文化 
import cul1 from './assets/product/culture/1.png'
import cul2 from './assets/product/culture/2.png'
import cul3 from './assets/product/culture/3.png'
import cul4 from './assets/product/culture/4.png'
import cul5 from './assets/product/culture/5.png'
import cul6 from './assets/product/culture/6.png'
// 6.erp
import erp1 from './assets/product/erp/1.png'
import erp2 from './assets/product/erp/2.png'
import erp3 from './assets/product/erp/3.png'
// 7 ding
import ding1 from './assets/product/ding/1.png'
import ding2 from './assets/product/ding/2.png'
import ding3 from './assets/product/ding/3.png'
import ding4 from './assets/product/ding/4.png'
import ding5 from './assets/product/ding/5.png'

export var productList = [
    [{
            name: '日常办公',
            content: '日常发起审批、费用报销、考勤打卡、周报月报计划等，提供多款办公应用覆盖团队协作与管理的各个方面。'
        }, {
            name: '审批流程',
            content: ['钉钉审批增强版，支持更复杂的审批单据设置、流程节点设置，流程流转分析、可对接第三方系统数据等。可以全面覆盖企业日常各类请假、出差、IT申请、行政服务申请、财务申请等。更可支持各类营销、项目、研发业务流程审批与管理，支持与ERP系统等对接。'],
            img: office1,
        },
        {
            name: '工作总结',
            content: ['钉钉日志增强版，日、周、月、季度、年、半年、阶段性七种周期性的计划与总结模板系统，计划与总结联动，目标管理更有效；点评互动，培养组织相互欣赏，相互促进的企业文化底蕴。'],
            img: office3,
        },
        {
            name: '考勤打卡',
            content: ['钉钉考勤增强版，依托钉钉原生考勤数据，支持更强大的考勤审批设置、考勤数据统计。'],
            img: office4,
        },
        {
            name: '规范制度',
            content: ['统一管理公司各类规章制度，提供严格权限控制与阅读审计的员工查询服务。覆盖企业规章制度的起草、审批、校对、发布、取消的全生命周期管理，支持规章制度的版本管理。'],
            img: office2,
        },
    ],
    [{
            name: '团队协作',
            content: '协作管理以事务为中心，跨组织、跨部门、跨岗位建立虚拟团队，大家在一个共同的协作主题中，交流沟通，反馈进展。同时，可关联业务工作流、新闻、客户联系人等，实现资源共享。'
        }, {
            name: '知识中心',
            content: ['比钉盘更全面的知识管理能力，支持多维多分类查询，支持文档上传时审批、通知推送、阅读明细、权限控制、点评推荐等。基于知识管理理念设计，帮助企业构建统一知识库的全过程管理，促进组织知识的沉淀、共享、学习、应用与创新。'],
            img: team1
        },
        {
            name: '日程安排',
            content: ['支持钉钉日程同步，可自定义群组日程，与全系统任务、会议、出差等流程集成。'],
            img: team2
        }, {
            name: '任务管理',
            content: ['钉钉任务增强版，提供任务安排、任务分解、跟踪、反馈、评价、查询、任务暂停、结项等全周期管理，提供按人员、按部门进行任务负荷度分析、满意度分析等度量手段，促进工作落地，提高执行效率。'],
            img: team3
        }, {
            name: '项目工作室',
            content: ['项目协作用于项目监控，将复杂的项目管理过程简化，让项目成员能够利用项目空间高效协作，合理分工，及时积累项目文档，提升项目知识经验，让项目管理人员随时监控项目进展，跟踪项目过程，掌握项目资源调配情况，精准评估项目绩效。'],
            img: team4
        },
    ],
    [{
            name: '客户在线',
            content: '统一管理销售各个环节，紧密跟踪客户的每一步；建立销售漏斗的全程跟踪管理，线索、客户、商机各个击破；并提供基于外勤地理位置、关联客户事项的拜访联系记录；自定义客户联系提醒规则，提供一站式的销售报表；优化销售过程，加强销售管理，提高销售业绩！'
        }, {
            name: '客户档案',
            content: ['详细登记客户的各类信息，包括客户的企业信息、财务信用信息、关键联系人信息等。在全面管理记录客户信息而方便各类统计查询的基础上，侧重管客户合同、回款及销售商机，同时通过和项目、人员、工作流、文档、邮件等系统关联，为用户全面、实时了解客户信息提供强有力的资讯管理平台。'],
            img: crm1
        },
        {
            name: '商机跟踪',
            content: ['通过客户联系记录对销售商机实现全程跟踪；通过销售漏斗实现对销售商机的阶段转换监控；根据商机类型、商机阶段、商机状态、有利因素、不利因素、关联项目进行级联查询或统计。'],
            img: crm2
        }, {
            name: '合同管理',
            content: ['登记客户相关的销售合同记录，实现合同记录的查询。根据合同类别、关联商机、关联项目、付款方式、产品、产品类别进行统计，关联商机、项目、客户联系人进行级联查询或统计，并可对合同开始日、合同终止日、交货期限、付款期限进行提前提醒'],
            img: crm3
        }, {
            name: '收款跟踪',
            content: ['通过收款登记管理，实现收款记录的查询，根据对应款项进行统计，关联合同进行级联查询或统计。'],
            img: crm4
        }, {
            name: '销售报表',
            content: ['客户分类、合同、回款，多维度客户跟进过程及销售订单情况分析，帮助管理人员更好的掌握团队业务情况，帮助更好的决策分析；'],
            img: crm5
        },
    ],
    [{
            name: '人事在线',
            content: '人事档案、人员招聘、人事流程、工资单发放、员工培训等人事工作统统搞定；帮助人事更高效的完成各类零碎的人事工作；帮助人事更好的与其他同事展开协作沟通。'
        }, {
            name: '人事档案',
            content: ['人事档案模块负责管理员工的人事档案和简历信息，支持与钉钉通讯录同步。提供对在职员工、解聘员工、离退员工的档案管理功能。考虑HR日常事务处理的各种使用场景，提供包括概览、预警提醒、员工经历自助维护、工资条发放等多项功能服务，节省重复工作量确保效率提升。'],
            img: hrm1
        },
        {
            name: '人员招聘',
            content: ['可以发起招聘申请、进行招聘岗位管理、应聘者信息管理、面试通知、offer审批、offer通知、入职准备等'],
            img: hrm2
        },
        {
            name: '人事流程：',
            content: ['实现人事入职、异动、合同等流程办理，流程通过后自动更新相关员工的人事档案信息。包括入职、转正、调岗、调薪、离职、退休、解聘、返聘、合同签订、合同变更、合同解除等。通过流程记录相关数据，以便将来实现人事相关报表的查询功能。'],
            img: hrm3
        },
        {
            name: '人事报表',
            content: ['员工生日、合同到期、试用到期、性别比例，学历分布，司龄分布，类别分布，职务等级，异动情况，婚姻状况等，提供多维度在职图表，人事概况一目了然；'],
            img: hrm6
        },
    ],
    [{
            name: '行政管理',
            content: '实现公司制度的有效发布，通过内部公司信息门户发布制度，发布展示公司运营制度、财务制度、项目制度等；整合资产库，实现对资产全周期管理；实现会前准备、会中接待、会后执行的全套管理；实现对公司证照、用印、用章的统一管理。'
        }, {
            name: '固资管理',
            content: ['固资管理的核心是资产安全、资金占用及转移过程清晰化；关键手段是“帐=卡=物”，以卡记物，以帐管物，实现固资的全员化应用和流程化管理，包括资产从申购、入库登记、领用、调拨、维修、报废、资产报表、资产维护的全生命周期过程管理，方便资产管理员对资产的流向进行跟踪和监管。'],
            img: admin1
        },
        {
            name: '办公资源管理',
            content: ['对公共办公资源（如营业执照及其他证照、投影机、电视、音响、笔记本电脑等）从资源类别管理、资源信息登记、借用管理到资源使用情况报表输出进行资源全生命周期管理。实现资源管理信息化、合理化的目标。'],
            img: admin2
        }, {
            name: '办公用品管理',
            content: ['提供办公用品信息的统一管理与维护，包括各类胶水、纸张、笔记本等低值易耗品登记、库存管理、办公用品申请、用品领用情况的查询统计等全周期过程管理。'],
            img: admin3
        }, {
            name: '车辆管理',
            content: ['公用车辆（费用、车辆保养、维修）、驾驶员信息的统一管理。','通过统一调度，合理安排，节约用车资源'],
            img: admin4
        }, {
            name: '档案管理',
            content: ['统一管理公司各类纸质与电子档案卷宗。提供档案登记、借阅、鉴定、销毁等全生命周期管理。包括合同档案、项目过程文件、法务财务档案等。并可与公文管理（选购模块）、审批流程等模块对接归档操作，对这些模块中进行归档的文档进行借阅、鉴定和销毁等管理。'],
            img: admin5
        }, {
            name: '图书管理',
            content: ['统一管理企业的纸质图书资料，提供图书登记、借阅、领取及归还的全过程管理。'],
            img: admin6
        },
        {
            name: '证照管理',
            content: ['对公司的营业执照、组织机构代码证、税务登记证、资质证、劳动执法合格证、社保登记证、个人职称证、岗位资格证等证件进行管理。证照过期、年审预警提醒，防止遗失并保证按时年检，特制订本功能，证照及资料由专人负责统一保管。', ],
            img: admin7
        },
    ],
    [{
            name: '企业文化',
            content: '实现企业文化的塑造与推广，通过公司文化门户、员工生活门户使得企业文化潜移默化的感染每位员工。'
        }, {
            name: '网上调查',
            content: ['提供面向企业内部各类员工的网上调查功能，包括发起调查、审核、发布、在线参与调查、调查结果查阅等全生命周期管理。支持单选、多选、矩阵、问答、评分等题型，并支持题型扩展，可用于各类满意度调查、培训效果调查、工作环境调查等工作。支持问卷模板预置。'],
            img: cul1
        },{
            name: '员工黄页',
            content: ['提供一个统一搜索入口，支持多维度查找公司员工，集员工个人名片、个人相关知识、问答、学习、考试等信息于一体，将个人资料统一集中式展现。'],
            img: cul6
        }, {
            name: '员工活动',
            content: ['员工活动组织管理，包括活动计划审核、活动通知、员工在线报名，报名情况统计等，存留历史员工活动记录。'],
            img: cul2
        }, {
            name: '内部社区',
            content: ['打造组织文化的宣传阵地。可设置社区版块、帖子、积分管理、支持匿名发帖等。通过建立内部、使用友好的内部讨论区，让员工参与公司各项交流。'],
            img: cul3
        }, {
            name: '投票管理',
            content: ['钉钉投票增强版，支持发起投票、参与、查看、终止、催办投票的全周期管理，采集内部新想法、新建议，提升组织反馈力'],
            img: cul4
        }, {
            name: '信息公告',
            content: ['钉钉公告增强版，适用于企业新闻、公告、通知、员工活动消息，支持审批后发布，支持在线推送，保证全体员工及时接收。可针对每篇公告进行阅读权限控制、附件下载权限控制等。'],
            img: cul5
        }
    ],
    [{
        name: '扩展模块',
        content: '提供公文全生命周期管理，支持员工多种类型学习考试，私有第三方系统整合，与主流ERP软件无缝集成，包括用友金蝶SAP等ERP系统等30+系统集成，随需融合开放延伸'
    }, {
        name: '公文管理',
        content: ['提供了公文模板设置、起草公文、正文套红、打印、流程审批以及公文发布的全生命周期管理。支持word在线编辑、修改留痕、批注等功能。'],
        img: erp1
    },{
        name: '考试管理',
        content: ['提供员工自测练习、模拟考试和正式考核三种考试类型。适用与企业内部各类学习考试场景，让员工在规定的时间内完成在线考试任务，考试完成后自动出考试结果和总体考试分析，节省线下考试在人员投入和活动组织方面的时间和金钱的消耗。'],
        img: erp2
    },{
        name: 'ERP财务集成',
        content: ['包括用友金蝶SAP等ERP系统集成、跨系统单点登录组件、阿里云邮/Exchange等邮箱集成、专业报表软件、电子签章系统等30种以上系统集成方案。'],
        img: erp3
    }],
    [{
            name: '个性化钉钉 ',
            content: '钉钉+蓝凌全面集成，重新定义工作方式，构建以沟通为前端入口的高效移动办公平台；一键安装，基于钉钉的OA办公，打破时间和空间的限制，轻松高效完成工作任务。'
        }, {
            name: '自定义工作台',
            content: ['打造属于企业的专属智能工作门户，通过应用管理全面实现企业门户的自定义；'],
            img: ding1
        },
        {
            name: '专属考勤开放',
            content: ['钉钉考勤系统与蓝凌智能OA审批流程打通，将蓝凌智能OA审批数据写入到钉钉考勤中；自动打卡、刷脸识别、多地签到、考勤统计，让OA考勤更人性、更酷，考勤与HR流程打通让管理更方便。'],
            img: ding2
        }, {
            name: '专属日程开放',
            content: ['DING日程和蓝凌智能OA日程实现同步，支持增删改查同步；'],
            img: ding3
        }, {
            name: '消息通知配置',
            content: ['为企业提供去运营干扰，保证企业内部智能工作门户闭环；'],
            img: ding4
        }, {
            name: '私有定制',
            content: ['支持私有应用定制，帮助企业打造个性化业务应用；'],
            img: ding5
        }
    ],
]


// WEBPACK FOOTER //
// ./src/datas.js